/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description SavedSearchOptionModal constants
 */

export const DISABLE_EMAIL_NOTIFICATION =
  '@@nzr/modals/savedSearchOptionalModal/DISABLE_EMAIL_NOTIFICATION'
export const DISABLE_PUSH_NOTIFICATION =
  '@@nzr/modals/savedSearchOptionalModal/DISABLE_PUSH_NOTIFICATION'
export const ENABLE_EMAIL_NOTIFICATION =
  '@@nzr/modals/savedSearchOptionalModal/ENABLE_EMAIL_NOTIFICATION'
export const ENABLE_PUSH_NOTIFICATION =
  '@@nzr/modals/savedSearchOptionalModal/ENABLE_PUSH_NOTIFICATION'
export const RESET_TO_DEFAULT_STATE = '@@nzr/modals/savedSearchOptionalModal/RESET_TO_DEFAULT_STATE'
export const RECEIVE_SAVED_SEARCH = '@@nzr/modals/savedSearchOptionModal/RECEIVE_SAVED_SEARCH'
